export default "__VITE_ASSET__a71e876c__"